module.exports = __webpack_public_path__ + "img/vetar.9be2595a.png";